module.exports = __webpack_public_path__ + "media/images/new-epic-icon-1d864e65.png";